import { render, staticRenderFns } from "./test-customer-select.vue?vue&type=template&id=b196dec8"
import script from "./test-customer-select.vue?vue&type=script&lang=js"
export * from "./test-customer-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports